export const formatDuration = (totalSeconds) => {
  const s = Math.max(0, Number(totalSeconds) || 0);
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, "0")}`;
};

export const formatTotal = (totalSeconds) => {
  const s = Math.max(0, Number(totalSeconds) || 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}min`;
  return `${m}min ${String(sec).padStart(2, "0")}s`;
};

export const parseDuration = (minStr, secStr) => {
  const m = parseInt(minStr || "0", 10) || 0;
  const s = parseInt(secStr || "0", 10) || 0;
  return m * 60 + s;
};

export const splitDuration = (totalSeconds) => {
  const s = Math.max(0, Number(totalSeconds) || 0);
  return { minutes: Math.floor(s / 60), seconds: s % 60 };
};
